export const KEYS = {
  THEMING: {
    THEMING: 'CI / Design'
  }
};
